import React from 'react'
import Layout from './../components/layout/index'
import pp from "../assets/cancellation.png"

const sections = [
  {
    heading: "Cancellation & Refund Policy",
    paragraphs: [
      "In case you are not satisfied with our emailed publications, you can cancel your subscription any time and receive a prorated refund on the unmailed issues. Refund requests for packages including a database have to be exercised within 7 days of purchase. Refunds on the database element of the subscription are not possible as soon as the subscriber (or one of its members) downloads data from the database as a spreadsheet. Discounts for multi-year subscriptions will be adjusted before a refund is made."
    ]
  },
]

const Cancellation = () => {
  return (
    <Layout>
      {/* Hero Banner */}
      <div className="relative h-56 mb-12">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${pp})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pb-16">
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={index}>
              {section.heading && (
                <h2 className="text-lg font-semibold text-[#a07924] mb-2">{section.heading}</h2>
              )}
              <div className="space-y-3">
                {section.paragraphs.map((paragraph, pIndex) => (
                  <p key={pIndex} className="text-[#475569] text-base leading-relaxed">{paragraph}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Cancellation
